<template>
    <div
        class="tooltip"
        :style="tooltipStyle"
        ref="tooltip"
    >
        <div class="container align-middle scrollable-container" style="min-width: 250px;">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import {computed, defineEmits, onMounted, onUnmounted, ref} from 'vue';

// Props
const props = defineProps({
    position: {
        type: Object,
        default: () => ({ top: 0, left: -999 }),
    },
});

const emit = defineEmits(['close']);

const tooltip = ref(null);

// Computed property
const tooltipStyle = computed(() => ({
    top: `${props.position.top}px`,
    left: `${props.position.left}px`,
}));

const hideTooltip = () => {
    emit('close');
}

const handleTooltipClickOutside = (event) => {
    if (props.position.left == -999) {
        return
    }

    if (tooltip.value && !tooltip.value.contains(event.target)) {
        hideTooltip();
    }
}

const handleTooltipKeydown = (event) => {
    if (props.position.left == -999) {
        return
    }

    if (event.key === 'Escape') {
        hideTooltip();
    }
}

onMounted(() => {
    document.addEventListener('click', handleTooltipClickOutside);
    document.addEventListener('keydown', handleTooltipKeydown);
});

// Remove event listeners when component unmounts
onUnmounted(() => {
    document.removeEventListener('click', handleTooltipClickOutside);
    document.removeEventListener('keydown', handleTooltipKeydown);
});
</script>

<style scoped>
.tooltip {
    position: absolute;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: .5rem .75rem;
    color: #212529;
    visibility: visible;
    z-index: 1000;
    opacity: 1;
}

.tooltip::before {
    content: '';
    position: absolute;
    top: 50%;
    right: -16px; /* Adjust the distance from the tooltip box */
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent transparent white; /* Match tooltip background color */
}

.tooltip::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -19px; /* Creates a border-like shadow for the arrow */
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent transparent rgba(0, 0, 0, 0.1); /* Match tooltip shadow */
    z-index: -1;
}

.scrollable-container {
    max-height: 350px;
    overflow-y: auto;
    padding-right: 5px;
}
</style>
